module.exports = __webpack_public_path__ + "static/img/fi_bg.c44ca29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fi_bg.png
// module id = h7E4
// module chunks = 12